<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import URL from '@/views/newmis36/util/url'
  import Qs from 'qs'
  const type = 1;
  export default {
    name: 'channel',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {if(clickName =="delete"){
          this.$axios.get(URL.advertising.configDel+"?id="+row.id).then(res=> {
              if (res.code == 0) {
                  this.$message.success("suc");
                  this.$refs.childTable.defaultQueryData({type:type});
              }
          });
      }else if (clickName == "update" ){
          this.$refs.childUpdate.open(row);
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t("common.search") == clickName){
          this.$refs.childTable.defaultQueryData({type:type});
        }else if("新增" == clickName || window.$t("common.addNew") == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        model.value = model.key;
        //根据是否包含id更新还是添加
        this.dataChanage((model.id!=undefined && model.id!=null && model.id!='') ? URL.advertising.configEdit:URL.advertising.configSave,model,res => {
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
            this.$refs.childTable.defaultQueryData({type:type});
        }else{
            this.$message.error(res.message);
        }
      })
      },
      dataChanage(url,option,suc,fail){
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {

        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      },

    },
    data () {
      return {
        deleteIds:"",
        category:true,
        queryData:{},
        /*新增或更新*/
        updateData:{
            cols:[
              { title: 'id', field: 'id', hidden: true },
              { title: window.$t("txmis.advertising.type"), field: 'type',data:type, hidden:true,required: true},
              { title: window.$t("txmis.advertising.channel"), field: 'key',required: true},
            ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
                {click:window.$t("common.search"),auth:"sys:advertisingConfig:view"},
                {click:window.$t("common.addNew"),auth:"sys:advertisingConfig:save"}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.advertising.configQuery, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
              { title: window.$t("txmis.advertising.channel"), field: 'key'},
              { title: window.$t("txmis.advertising.createTime"), field: 'createDate'},
              {title:window.$t("common.handle"),btnClick:
                  [
                    {name:window.$t("common.edit"),click:"update",type:"primary",icon: "el-icon-edit",auth:"sys:advertisingConfig:edit"},
                    {name:window.$t("common.delete"),click:"delete",type:"primary",icon:"el-icon-delete",auth:"sys:advertisingConfig:delete"},
                  ]},

          ]
        }
      }
    }
  }
</script>
